import { SvgIcon, type SvgIconProps } from '../layout/SvgIcon';

export const MultiplyIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 8 8">
        <path d="M.872.465a.75.75 0 0 0 0 1.06l2.44 2.44-2.51 2.51a.75.75 0 0 0 1.06 1.06l2.51-2.51 2.51 2.51a.75.75 0 1 0 1.061-1.06l-2.51-2.51 2.44-2.44A.75.75 0 0 0 6.811.465l-2.44 2.44-2.44-2.44a.75.75 0 0 0-1.06 0Z" />
    </SvgIcon>
);
